import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { LocalStorageService } from '../storage/local-storage.service';
import { SESSION_STORAGE_KEY } from '../storage/storage.constant';

export const guestGuard: CanActivateFn = (): boolean | UrlTree => {
  const router = inject(Router);
  const localStorageService = inject(LocalStorageService);
  const isLoggedIn = !!localStorageService.getItem(SESSION_STORAGE_KEY.ACCESS_TOKEN);

  return isLoggedIn ? router.createUrlTree(['/dashboard']) : true;
};
